import React, { useEffect, useState } from "react";
import "../../index.css";
import Logo from "../../helper/svg/LOGO.svg";
import { Link } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { RiInstagramFill, RiTwitterXFill } from "react-icons/ri";
import { useTranslation } from "../../hooks/useTranslation";
import Chat from "../../pages/AIChat";
import Headset from "../../helper/svg/headphn.svg";
import { getUserById } from "../../api/common";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";

const PopupModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
      <div
        className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[845px] relative sm:shadow-lg
                           max-h-[90vh] overflow-y-auto"
      >
        <button
          onClick={onClose}
          className="sticky top-[10px] right-[10px] p-2 float-right text-[#9E9E9E] hover:text-black bg-white"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

const Footer = () => {
  const { t } = useTranslation();
  const { token } = useAuth()
  const [isChatPopupOpen, setIsChatPopupOpen] = useState(true);
  const location = useLocation();

  const { data } = useQuery({
    queryKey: ["user"],
    queryFn: () => getUserById(),
  });
  const { data: userData } = data ?? {};

  useEffect(() => {
    if (token && location.pathname === "/") {
      setIsChatPopupOpen(true);
    } else {
      setIsChatPopupOpen(false);
    }
  }, [token, location.pathname]);

  return (
    <div className="bg-[#FFF3EF] pt-[60px] pb-[17px]">
      <div className="container">
        <div className="grid lg:grid-cols-[auto_auto_auto_auto] md:grid-cols-2 justify-between lg:gap-[50px] gap-5 pb-[40px]">
          <div className="max-w-[398px]">
            <img src={Logo} alt="" />
            <p className="text-[15px] leading-6 text-[#797B78] mt-[24px]">
              {t("footer").description}
            </p>
          </div>
          <div className="mt-[21px] max-w-[242px]">
            <h3 className="text-base text-black font-semibold leading-[19px] mb-4">
              {t("footer").openingTitle}
            </h3>
            <ul className="flex flex-col gap-[8px]">
              <li className="text-[#797B78] text-base leading-[19px]">
                {t("footer").openingHours.satWed}
              </li>
              <li className="text-[#797B78] text-base leading-[19px]">
                {t("footer").openingHours.thuWed}
              </li>
              <li className="text-[#797B78] text-base leading-[19px]">
                {t("footer").openingHours.fridayClosed}
              </li>
            </ul>
          </div>
          <div className="mt-[21px] max-w-[87px]">
            <h3 className="text-base text-black font-semibold leading-[19px] mb-4">
              {t("footer").userLinks}
            </h3>
            <ul className="flex flex-col gap-[8px]">
              <li className="text-[#797B78] text-base leading-[19px]">
                <Link to="/about" className="">
                  {t("footer").aboutUs}
                </Link>
              </li>
              <li className="text-[#797B78] text-base leading-[19px]">
                <Link to="/" className="">
                  {t("footer").contactUs}
                </Link>
              </li>
              <li className="text-[#797B78] text-base leading-[19px]">
                <Link to="/privacy" className="">
                  {t("footer").privacyPolicy}
                </Link>
              </li>
              <li className="text-[#797B78] text-base leading-[19px]">
                <Link to="/terms" className="">
                  {t("footer").termsOfUse}
                </Link>
              </li>
            </ul>
          </div>
          <div className="mt-[21px] max-w-[339px]">
            <h3 className="text-base text-black font-semibold leading-[19px] mb-4">
              {t("footer").contactTitle}
            </h3>
            <p className="text-[#797B78] text-base max-w-[174px]">
              {t("footer").address}
            </p>
            <div className="flex items-center gap-[16px] mt-[24px]">
              <Link className="w-[48px] h-[48px] bg-white rounded-full flex items-center justify-center hover:bg-[#FFA808] group">
                <FaFacebookF
                  size={20}
                  className="text-[#4CAF50] group-hover:text-[#fff]"
                />
              </Link>
              <Link className="w-[48px] h-[48px] bg-white rounded-full flex items-center justify-center hover:bg-[#FFA808] group">
                <RiTwitterXFill
                  size={20}
                  className="text-[#4CAF50] group-hover:text-[#fff]"
                />
              </Link>
              <Link className="w-[48px] h-[48px] bg-white rounded-full flex items-center justify-center hover:bg-[#FFA808] group">
                <RiInstagramFill
                  size={20}
                  className="text-[#4CAF50] group-hover:text-[#fff]"
                />
              </Link>
              <Link className="w-[48px] h-[48px] bg-white rounded-full flex items-center justify-center hover:bg-[#FFA808] group">
                <FaLinkedinIn
                  size={20}
                  className="text-[#4CAF50] group-hover:text-[#fff]"
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="pt-[16px] border-t border-[#E5E5E5] text-[#797B78] grid md:grid-cols-2 grid-cols-1 justify-between gap-[10px]">
          <p className="text-sm">©{new Date().getFullYear()} {t("footer").copyright}</p>
          <ul className="flex  gap-[32px] flex-wrap md:justify-end">
            <li className="text-[#797B78] text-sm leading-[16px]">
              <Link to="/privacy" className="">
                {t("footer").privacyPolicy}
              </Link>
            </li>
            <li className="text-[#797B78] text-sm leading-[16px]">
              <Link to="/terms" className="">
                {t("footer").termsOfUse}
              </Link>
            </li>
          </ul>
        </div>

        {userData?._id && (
          <div
            onClick={() => setIsChatPopupOpen(true)}
            className="fixed bottom-[10%] right-[0px] cursor-pointer bg-[#FF9D00] z-10 flex items-center justify-center py-[15px] px-[30px] rounded-l-[100px] gap-[15px] shadow-[0px_0px_21px_#1100ff4d] text-white text-[16px] font-semibold"
          >
            <img src={Headset} alt="" className="w-full max-w-[30px] " />
            {t("customersupport").support}
          </div>
        )}
      </div>

      <PopupModal
        isOpen={isChatPopupOpen}
        onClose={() => setIsChatPopupOpen(false)}
      >
        <Chat></Chat>
      </PopupModal>
    </div>
  );
};

export default Footer;
